import en from "./en";
import cn from "./zh-cn";
import tw from "./zh-tw";
export default{
    en:en,
    cn:cn,
    tw:tw,
}